import { Formik } from 'formik';
import { Starttask } from '../../../Slices/timerslice';
import { getOptionsByPath } from '../../../utilsdata';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Modal, Form, Typography, Row, Col } from 'antd';
import { AntdButton, SelectInput } from '../../../blueplanitUtils/InputField';
import { updateWorkHistoryThunk } from '../../../Slices/orderSlice';
import { REQUEST, REQUEST_SERVICES_TIMER, REQUEST_TASK_TIMER } from '../../../Dropdownmanager';

const CreateOrder = (props) => {
    const { open, handleClose, RequestInfoState } = props;

    const RequestInfo = useSelector((state) => state.orders.singleOrder)
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const dispatch = useDispatch();
    const initialValues = {

        requestId: RequestInfo.requestId,
        clientName: '',
        processType: '',
        taskType: '',
        email: '',
        subject: '',
        body: '',
    }

    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

    const submit = async (values) => {
        if (!values.taskType || !values.processType) {
            return;
        }

        setIsSubmitting(true);

        try {
            const valuesObject = {
                userId: loginUser?.id.toString(),
                emailId: RequestInfo.id,
                requestId: RequestInfo.requestId || '',
                clientName: RequestInfoState?.clientName ? RequestInfoState.clientName : RequestInfo?.clientName || " ",
                processType: values.processType,
                taskType: values.taskType,
                email: values?.email,
                subject: values?.subject,
                body: values?.body,
                startTime: Date.now().toString(),
                endTime: "",
                department: 'Operations'
            };

            await dispatch(updateWorkHistoryThunk(valuesObject)).unwrap();

            const payload = {
                department: 'Operations',
                task: values.taskType,
                time: Date.now(),
                requestId: RequestInfo.requestId,
            };

            localStorage.setItem('time', new Date().getTime());
            localStorage.setItem('task', values.taskType);
            localStorage.setItem('department', "Operations");
            localStorage.setItem('requestId', RequestInfo.requestId.toString());

            dispatch(Starttask(payload));

            handleClose();
        } catch (error) {
            console.log(error);
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Modal
                open={open}
                onCancel={handleClose}
                footer={null}
                width="50%"
                centered
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={submit}
                >
                    {({ handleChange, handleSubmit, values, errors, touched }) => (
                        <form noValidate onSubmit={handleSubmit}>
                            <Row gutter={16}>
                                <Col span={10}>
                                    <Form.Item label="Request#">
                                        <Typography.Text strong>{RequestInfo?.requestId}</Typography.Text>
                                    </Form.Item>
                                </Col>
                                <Col span={14}>
                                    <Form.Item label="Client Name">
                                        <Typography.Text strong>
                                            {RequestInfoState?.clientName
                                                ? RequestInfoState.clientName
                                                : RequestInfo?.clientName || "N/A"}
                                        </Typography.Text>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item >
                                        <SelectInput
                                            label="Services"
                                            name="processType"
                                            value={values.processType}
                                            onChange={(value) => handleChange({ target: { name: 'processType', value } })}
                                            options={getOptionsByPath(NestedDatabucket, [REQUEST, REQUEST_SERVICES_TIMER])}
                                        />

                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item >
                                        <SelectInput
                                            label="Task"
                                            name="taskType"
                                            value={values.taskType}
                                            onChange={(value) => handleChange({ target: { name: 'taskType', value } })}
                                            options={getOptionsByPath(NestedDatabucket, [REQUEST, REQUEST_TASK_TIMER])}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row justify="end" gutter={16}>
                                <Col>
                                    <AntdButton label="Cancel" onClick={handleClose} variant="outlined" />

                                </Col>
                                <Col>
                                    <AntdButton
                                        label={isSubmitting ? "Submitting..." : "Submit"}
                                        type="primary"
                                        htmlType="submit"
                                        disabled={isSubmitting}
                                    />

                                </Col>
                            </Row>
                        </form>
                    )}
                </Formik>
            </Modal>
        </>
    )
}
export default CreateOrder;